// Suggested tags + per-tag color scheme. Free-form custom tags fall back to gray.

export const SUGGESTED_TAGS = [
  // Team / outreach assignment — who's chasing this draw on the admin side.
  // Mutually exclusive; managed by the Team dropdown on the submission
  // detail page in addition to the freeform TagEditor.
  'AARON',
  'ANDALIS',
  'Urgent',
  'VIP',
  'Repeat Visit',
  'Difficult Stick',
  'Pediatric',
  'Elderly',
  'Wheelchair Access',
  'Spanish Speaker',
  'Russian Speaker',
  'Mandarin Speaker',
  'Fasting',
  'Pre-Op',
  'Same Day',
  'After Hours',
];

// Team-assignment tags that should be treated as mutually exclusive. Setting
// one via the Team dropdown drops the other.
export const TEAM_TAGS = ['AARON', 'ANDALIS'];

const TAG_COLORS = {
  AARON:               'blue',
  ANDALIS:             'orange',
  Urgent:              'red',
  VIP:                 'purple',
  'Repeat Visit':      'blue',
  'Difficult Stick':   'orange',
  Pediatric:           'cyan',
  Elderly:             'teal',
  'Wheelchair Access': 'teal',
  'Spanish Speaker':   'yellow',
  'Russian Speaker':   'yellow',
  'Mandarin Speaker':  'yellow',
  Fasting:             'pink',
  'Pre-Op':            'orange',
  'Same Day':          'red',
  'After Hours':       'purple',
};

export function tagColor(tag) {
  return TAG_COLORS[tag] || 'gray';
}
